module.exports = __webpack_public_path__ + "assets/antyLogo.904ddf24.svg";